export default "__VITE_ASSET__053d396c__"